export default __webpack_public_path__ + "static/media/banner-bg.b81008e7.svg";